import apiAgent from '../api/AgentAPI';
import SetupData from '../data/SetupData';

const getBDInfo = async (sourceId) => {
    const result = await apiAgent.getBDInfo(sourceId);
    return result;
};

const getPostingAccess = async (agentId) => {
    const result = await apiAgent.getPostingAccess(agentId);
    return result;
};

const getPropStoryAccess = async (agentId) => {
    const result = await apiAgent.getPropStoryAccess(agentId);
    return result;
};

const getPackage = async (agentId) => {
    const result = await apiAgent.getPackage(agentId);
    return result;
};

const searchById = async (id) => {
    const result = await apiAgent.searchById(id);
    return result;
};

const login = async (credential) => {
    const result = await apiAgent.login(credential);
    return result;
};

const forgotPassword = async (username) => {
    const result = await apiAgent.forgotPassword(username);
    return result;
};

//for manual plotting check agent plotting recommendations
// manual plotting feature is removed
const isPlotted = async (id) => {
    // const result = await apiAgent.isPlotted(id);
    // return result;
};

const getEcardUrl = async (agentId) => {
    const result = await apiAgent.getEcardUrl(agentId);
    return result;
};

const isTrr = (company) => {
    return (!company || company === SetupData.trrCompany);
};

const uploadImage = async (agent, codebase64) => {
    const defaultFileName = `profile`;
    const params = {
        id: agent._id,
        codebase64: codebase64,
        fileName: defaultFileName
    };
    const imageUri = await apiAgent.uploadImage(params);
    return imageUri;
};

const uploadOnlineImage = async (agent, codebase64) => {
    const defaultFileName = `online`;
    const params = {
        id: agent._id,
        codebase64: codebase64,
        fileName: defaultFileName
    };
    const imageUri = await apiAgent.uploadImage(params);
    return imageUri;
};

const uploadOfflineImage = async (agent, codebase64) => {
    const defaultFileName = `offline`;
    const params = {
        id: agent._id,
        codebase64: codebase64,
        fileName: defaultFileName
    };
    const imageUri = await apiAgent.uploadImage(params);
    return imageUri;
};

const setTnc = async (agent) => {
    const result = await apiAgent.setTnc(agent);
    return result;
};

const save = async (agent) => {
    const updatedAgent = await apiAgent.save(agent);
    return updatedAgent;
};

const handleLoggedInAgent = async (agent) => {
    if (agent.active === 'Temporary Out of Service') {
        agent.TOOS = true
    }
    agent.reminder = { expireToday: true, expireIn10days: true, expireIn30days: true }

    const packageInfo = await getPackage(agent._id)
    const postingAccess = await getPostingAccess(agent._id);
    const bdInfo = await getBDInfo(agent.source);

    let loggedInAgent = {
        ...agent,
        packageInfo,
        postingAccess,
        bdInfo,
        //   isPlotted: true,
    }

    // if (!agent.loc || !agent.state || !agent.area || (!agent.state && !agent.area)) {
    //   loggedInAgent.isPlotted = false
    // }
    return loggedInAgent
}

const singleSignOn = async (secretKey) => {
    const result = await apiAgent.singleSignOn(secretKey);
    return result;
};

export default {
    getBDInfo,
    getPostingAccess,
    getPropStoryAccess,
    getPackage: getPackage,
    searchById: searchById,
    login: login,
    forgotPassword: forgotPassword,
    isPlotted: isPlotted,
    getEcardUrl: getEcardUrl,
    isTrr: isTrr,
    uploadImage: uploadImage,
    uploadOnlineImage: uploadOnlineImage,
    uploadOfflineImage: uploadOfflineImage,
    setTnc: setTnc,
    save: save,
    handleLoggedInAgent: handleLoggedInAgent,
    singleSignOn,
};
